import { ScanResult } from '../docqr.domain';
import { buildDocQrResultUrl } from './docqrUrl';

function createCacheBustValue(): string {
    return Date.now().toString();
}

export interface IDocQrService
{
  getDocQrResult(werkmaatschappij:string, projectcode:string, documentnummer:string, revisie:string, revisiedatum:string) : Promise<ScanResult>;
}

export class DocQrService implements IDocQrService
{

    public async getDocQrResult(werkmaatschappij:string, projectcode:string, documentnummer:string, revisie:string, revisiedatum:string) : Promise<ScanResult> {
    
        const resultUrl = buildDocQrResultUrl(process.env.REACT_APP_DOCQR_API_BASEURL, werkmaatschappij, projectcode, documentnummer, revisie, revisiedatum);
        const fragmentIndex = resultUrl.indexOf('#');
        const urlWithoutFragment = fragmentIndex === -1 ? resultUrl : resultUrl.slice(0, fragmentIndex);
        const fragment = fragmentIndex === -1 ? '' : resultUrl.slice(fragmentIndex);
        const cacheBustSeparator = urlWithoutFragment.includes('?') ? '&' : '?';
        const url = `${urlWithoutFragment}${cacheBustSeparator}cacheBust=${encodeURIComponent(createCacheBustValue())}${fragment}`;

        try {

            var response = await fetch(url);
            
            if(response.ok) {

                let result: ScanResult = await response.json();
                result.isSuccess = true;

                return result;
            }
            else {
                const errorMessage: string = await response.text();

                throw new Error(errorMessage || response.statusText);
            } 
        } catch (error) {

            let result = new ScanResult();

            result.isSuccess = false;

            if (error instanceof Error) {
                result.errorMessage = error.message;
            }
            
            return result;
        }
    }

}
